import React, { createContext, useContext, useState, ReactNode } from "react";

interface OrganizationSwitchContextType {
  isSwitching: boolean;
  setIsSwitching: (switching: boolean) => void;
}

const OrganizationSwitchContext = createContext<
  OrganizationSwitchContextType | undefined
>(undefined);

export const useOrganizationSwitch = () => {
  const context = useContext(OrganizationSwitchContext);
  if (context === undefined) {
    throw new Error(
      "useOrganizationSwitch must be used within an OrganizationSwitchProvider"
    );
  }
  return context;
};

interface OrganizationSwitchProviderProps {
  children: ReactNode;
}

export const OrganizationSwitchProvider: React.FC<
  OrganizationSwitchProviderProps
> = ({ children }) => {
  const [isSwitching, setIsSwitching] = useState(false);

  return (
    <OrganizationSwitchContext.Provider value={{ isSwitching, setIsSwitching }}>
      {children}
    </OrganizationSwitchContext.Provider>
  );
};
